module.exports = __webpack_public_path__ + "static/media/brick-wall.c25c26f5.jpg";